import React from 'react';
import './LoadingScreen.scss';
import loadingAnimation from '../../../assets/icons/drp-navy-spinner.gif';
import FormatMessage from '../../../features/messages/FormatMessage';

type Props = {
  messageId: string;
  path?: string;
};

export const LoadingScreen: React.FC<Props> = ({ messageId }) => {
  return (
    <div className={'hatters-flex-column-container loading-screen-container'}>
      <span className={'flex-spacer-small'} />

      <div className="loading-screen-wrapper">
        <img src={loadingAnimation} className={'loading-screen-icon'} alt={''} />

        <div className={'loading-screen-message'}>
          <FormatMessage id={messageId} />
        </div>
      </div>

      <span className={'flex-spacer-large'} />
    </div>
  );
};
